import cx from 'clsx';
import { ReactElement } from 'react';

type Props = {
  name?: string;
  src?: string;
  icon?: ReactElement;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl';
  bgColor?: string;
  className?: string;
};

const getInitialsFromName = ({ name }: Pick<Props, 'name'>) => {
  const splitName = name && name.split(' ');
  let initials = splitName && splitName[0].substring(0, 1).toUpperCase();

  if (splitName && splitName.length > 1) {
    initials += splitName[splitName.length - 1].substring(0, 1).toUpperCase();
  }
  return initials;
};

const getSizeClassNames = ({ size }: Pick<Props, 'size'>) => {
  if (size === 'xs') {
    return 'w-6 h-6';
  }
  if (size === 'sm') {
    return 'w-8 h-8';
  }
  if (size === 'md') {
    return 'w-12 h-12';
  }
  if (size === 'lg') {
    return 'w-16 h-16';
  }
  if (size === 'xl') {
    return 'w-20 h-20';
  }
  if (size === 'xxl') {
    return 'w-40 h-40';
  }
  // by default width is 48 px
  return 'w-12 h-12';
};

export const Avatar = ({ name, src, icon, size = 'md', bgColor, className, ...rest }: Props) => {
  const initials = name ? getInitialsFromName({ name }) : '';

  return (
    <div
      className={cx(
        'flex items-center justify-center',
        'rounded-full',
        'font-bold text-gray-800 uppercase',
        getSizeClassNames({ size }),
        bgColor ? bgColor : 'bg-gray-200',
        className
      )}
      role={src == null ? 'img' : undefined}
      {...rest}
    >
      {icon && <icon.type className={cx(size === 'xl' || size === 'lg' ? 'w-8 h-8' : 'w-5 h-5')} />}
      {src && <img src={src} alt={name} className="object-cover w-full h-full rounded-full" />}
      {!src && !icon && (
        <div
          className={cx(
            (size === 'xs' || size === 'sm') && 'text-xs',
            (size === 'lg' || size === 'xl') && 'text-base',
            size === 'md' && 'text-sm',
            'font-semibold'
          )}
        >
          {initials}
        </div>
      )}
    </div>
  );
};
